export const INSERT_CAMPAIGN_DETAILS = "INSERT_CAMPAIGN_DETAILS";
export const INSERT_BILLING_DETAILS = "INSERT_BILLING_DETAILS";
export const INSERT_PROGRESS_DETAILS = "INSERT_PROGRESS_DETAILS";
export const GET_PREVIOUS_CARDS = "GET_PREVIOUS_CARDS";
export const RESET_CREATE_CAMPAIGN = "RESET_CREATE_CAMPAIGN";